<template>
  <div>
    <!-- <h1>{{ task.task }}</h1>
    <div>{{ task.locType1Code }}</div> -->
    
    <div v-if="members.length > 0" class="mg-b-10 bg-gray-50 bd divide-y-2">
        
      <div v-for="m in members.filter(x=>!x.isOwner)" :key="m.id" class="d-flex align-items-center bd-b bd-gray-200">
        <div>
          <img :src="m.avator" class="rounded-circle" alt />
        </div>
        <div class="mg-l-10">
            {{ m.displayName }}
            <div class="text-muted tx-12">
            <feather type="phone" style="max-width: 12px !important; max-height: 12px !important; font-size: 12px !important;" />
            {{ m.mobile }}
            </div>
            <!-- <div class="text-muted tx-12">{{ m.seen? 'Харсан' : 'Хараагүй' }}</div> -->
        </div>
        <div class="mg-l-auto mg-r-10 pd-y-5">
            <div v-if="$store.state.user.userInfo.user_id == task.userId || hasPermission(['admin'])">
              <div v-if="membersInvoice.find(x=>x.userId == m.userId)?.executeFlag == 2" class="tx-success">
                <feather type="check-circle" />
                Дэмжсэн
              </div>
              <div v-else-if="membersInvoice.find(x=>x.userId == m.userId)?.executeFlag == 1">
                <feather type="check-circle" />
                Дэмжээгүй <span class="alert alert-danger pd-y-2 pd-x-5 mg-l-10">Шалтгаан({{ membersInvoice.find(x=>x.userId == m.userId)?.execution }})</span>
              </div>
              <div v-else-if="invoiceTask.i7 == 2" class="alert alert-warning pd-y-2">
                Буцаагдсан төлөвт байгаа
              </div>
              <div v-else-if="invoiceTask.i7 == 1" class="alert alert-warning pd-y-2">
                <!-- Баталгаажсан төлөвт байгаа -->
              </div>
              <div v-else class="alert alert-warning pd-y-2">
                Хүлээгдэж буй
              </div>
            </div>
            <div v-else-if="$store.state.user.userInfo.user_id===m.userId">
                <div class="d-flex">
                    <div @click="setFlag(2)" class="" role="button">
                      <feather :type="getExecuteFlag(m.userId)==2 ? 'check-circle' : 'circle'" />
                      Дэмжинэ
                    </div>
                    <div @click="setFlag(1)" class="mg-l-10" role="button">
                      <feather :type="getExecuteFlag(m.userId)==1 ? 'check-circle' : 'circle'" />
                      Дэмжихгүй
                    </div>
                </div>
                <div class="d-flex align-items-center mg-t-5" v-if="getExecuteFlag(m.userId)==1">
                    <input v-model="m.execution" class="form-control ht-30 wd-400" placeholder="Шалтгаан"
                    style="border-radius: 4px 0 0 4px" />
                    <div @click="setExecution(m.execution)" class="btn btn-xs btn-warning" style="border-radius: 0 4px 4px 0; margin-left: -1px">
                        <feather type="check-square" />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div v-else-if="task.locType1Code !== 'exam'">
      <div v-if="invoiceTask.i7 === 2" class="alert alert-warning">
        Буцаагдсан {{ invoiceTask.s11 }}
      </div>
      <div v-else-if="invoiceTask.i7 === 1" class="alert alert-info">
        Баталгаажсан
      </div>
      <div v-else-if="invoiceTask.i7 === 0 && invoiceTask.isTender" class="alert alert-info">
        Төлбөр төлөгдсөн
      </div>
    </div>

    <!-- {{ task.task }}
    {{ task.userId }}
    {{ $store.state.user.userInfo.user_id }} -->
    <div class="form-group" v-if="
    ($store.state.user.userInfo.user_id == task.userId 
    || hasPermission(['admin'])
    )
     && !(invoiceTask.i7 == 2 || invoiceTask.i7 == 1) && !invoiceTask.isTender">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Буцаах бол тайлбар бичнэ үү</label>
        <textarea v-model="shaltgaan" :rows="3" class="form-control" placeholder="Буцаасан шалтгаан"></textarea>
    </div>
    
    <div class="d-flex justify-content-between bd-t pd-t-10 mg-t-10"
    v-if="($store.state.user.userInfo.user_id == task.userId 
    || hasPermission(['admin'])
    )
    && !(invoiceTask.i7 == 2 || invoiceTask.i7 == 1) && !invoiceTask.isTender">
        <div @click="butsaah()" class="btn btn-danger">Буцаах</div>
        <div @click="batlah()" class="btn btn-primary">Батлах</div>
    </div>

    <!-- {{ invoiceTask.i7 }} {{ invoiceTask.id }} -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import { MessageBox, Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { hasOneOf } from "@/libs/tools";


export default {
  components: {
    MessageBox,
    Message
  },
  props: {
    taskId: {
      type: Number,
      default: () => 0
    },
    invoiceTask: {
      type: Object,
      default: () => {}
    }
  },
  name: 'ReqDetail',
  data() {
    return {
      task: {},
      shaltgaan: '',
      members: [],
      membersInvoice: []
    };
  },
  mounted() {
    // console.log('invoiceTask', this.invoiceTask);
    this.init();
  },
  methods: {
    hasPermission(arr){
      return hasOneOf(arr, this.$store.state.user.userInfo.access);
    },
    getExecuteFlag(userId){
      console.log('getExecuteFlag', this.membersInvoice.find(x=>x.userId == userId));
      return this.membersInvoice.find(x=>x.userId == userId)?.executeFlag;
    },
    setExecution(execution) {
      request({
        api: { method: "POST", url: "TaskInUser/postExecution" },
        data: { 
          taskId: this.invoiceTask.id, 
          execution: execution,
          executionHistoryFlag: 0
        },
        store: this.$store
      }).then(res => {
        if(res != false){
          this.$bvToast.toast('Амжилттай', {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "success",
            toaster: "b-toaster-bottom-left"
          });
        }
      });
    },
    setFlag(flag) {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.invoiceTask.id },
        store: this.$store
      }).then(res => {
        if(res != false){
          if(res.data.task.i7 == 2){
            this.$bvToast.toast('Буцаагдсан төлөвт байгаа хүсэлтэд үйлдэл хийх боломжгүй.', {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
            return;
          } else if(res.data.task.i7==1){
            this.$bvToast.toast('Баталгаажсан төлөвт байгаа хүсэлтэд үйлдэл хийх боломжгүй.', {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
            return;
          } else{
            request({
              api: { method: "POST", url: "TaskInUser/SetExecuteFlag" },
              data: { 
                  taskId: this.invoiceTask.id,
                  userId: this.$store.state.user.userInfo.user_id,
                  executeFlag: flag
              },
              store: this.$store
            }).then(res => {
              if(res != false){
                this.$bvToast.toast('Амжилттай', {
                  title: "Мэдэгдэл",
                  autoHideDelay: 3000,
                  appendToast: true,
                  variant: "success",
                  toaster: "b-toaster-bottom-left"
                });
                this.invoiceMembers();
              }
            });
          }
        }
      });
    },
    init() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.taskId },
        store: this.$store
      }).then(res => {
        if(res != false){
          this.task = res.data.task;
          // console.log('task', this.task);

          if(this.task.locType1Code == "exam"){
            this.checkInvoiceStatus();
            this.initMembers();
            this.shaltgaan = this.invoiceTask.s11;
          }
        }
      });
    },
    checkInvoiceStatus(){
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.invoiceTask.id },
        store: this.$store
      }).then(res => {
        if(res != false){
          if(res.data.task.i7 == 2){
            this.$bvToast.toast('Буцаагдсан төлөвт байгаа хүсэлтэд үйлдэл хийх боломжгүй.', {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
          } else if(res.data.task.i7===1){
            this.$bvToast.toast('Баталгаажсан төлөвт байгаа хүсэлтэд үйлдэл хийх боломжгүй.', {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
          }
        }
      });
    },
    initMembers() {
      request({
        api: { method: "GET", url: "TaskInUser/GetInheritedList" },
        params: { taskId: this.taskId, page: 0, size: 1000 },
        store: this.$store
      }).then(res => {
        if(res != false){
          this.members = res.data.users;
          console.log('TaskInUser/GetInheritedList', res.data.users);
          this.invoiceMembers();
        }
      });
    },
    invoiceMembers() {
      request({
        api: { method: "GET", url: "TaskInUser/GetInheritedList" },
        params: { taskId: this.invoiceTask.id, page: 0, size: 1000 },
        store: this.$store
      }).then(res => {
        if(res != false){
          console.log('invoice members', res.data.users);
          this.membersInvoice = res.data.users;
        }
      });
    },
    butsaah(){
        if(!hasOneOf(['admin'], this.$store.state.user.userInfo.access)){
          this.$bvToast.toast('Та буцаах үйлдэл хийх эрхгүй байна.', {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left"
          });
          return;
        }
      
        let errs=[];
        if(this.shaltgaan == ''){
            errs.push('Буцаасан шалтгаан оруулна уу.');
        }
        if(errs.length > 0){
            this.$bvToast.toast(errs.join('\n'), {
                title: "Заавал бөглөх талбар",
                autoHideDelay: 3000,
                appendToast: true,
                variant: "warning",
                toaster: "b-toaster-bottom-left"
            });
            return;
        }

        let _model={};

        request({
          api: { method: "GET", url: "task/taskInheritedDetail" },
          params: { id: this.invoiceTask.id },
          store: this.$store,
        }).then((res) => {
            if(res != false){
                _model = res.data.task;
                _model.i7= 2;
                _model.s11= this.shaltgaan;

                request({
                    api: { method: "POST", url: "Task/PostInherited" },
                    data: { model: _model },
                    store: this.$store
                }).then(res => {
                    this.$bvToast.toast('Амжилттай буцаагдлаа.', {
                        title: "Мэдэгдэл",
                        autoHideDelay: 3000,
                        appendToast: true,
                        variant: "info",
                        toaster: "b-toaster-bottom-left"
                    });
                    if(this.task.locType1Code == "exam"){
                      this.removeMembersFromInvoice();
                    }
                    
                    this.$emit('on-hide');
                });
            }
        });

        
    },

    batlah(){
      if(!hasOneOf(['admin'], this.$store.state.user.userInfo.access)){
        this.$bvToast.toast('Та батлах үйлдэл хийх эрхгүй байна.', {
          title: "Мэдэгдэл",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
        return;
      }

      if(this.task.locType1Code == "exam"){
        this.examBatlah();
      }else{
        this.trainingBatlah();
      }
    },
    examBatlah(){

      if(!this.hasPermission(['admin'])){
        let minRequiredObjectCount = 1;
        if(this.task.locType1Code == "team3"){
          minRequiredObjectCount = 2;
        } else if(this.task.locType1Code == "team5"){
          minRequiredObjectCount = 3;
        } else if(this.task.locType1Code == "team7"){
          minRequiredObjectCount = 5;
        }
        if(this.membersInvoice.filter(x=>x.executeFlag==2).length < minRequiredObjectCount){
          this.$bvToast.toast(
            `Хамгийн багадаа ${minRequiredObjectCount}-н хүн дэмжсэн байх шаардлагатай.`
            , {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left"
          });
        }
        return;
      }

      MessageBox.confirm(
        `Уг хүсэлтийн хяналтийн зөвлөл ${this.members.filter(x=>!x.isOwner).length}-н хүний бүрэлдэхүүнтэй бөгөөд
        одоогоор ${this.membersInvoice.filter(x=>x.executeFlag==2).length}-н хүн дэмжсэн байна.
        Та баталгаажуулах уу?`
      , 'Санамж', {
        confirmButtonText: 'Тийм',
        cancelButtonText: 'Үгүй',
        type: 'warning'
      }).then(() => {
        this.trainingBatlah();
      }).catch(() => {
        console.log('Батлагдсангүй');
      });
    },

    trainingBatlah(){
        let _model={};

        request({
          api: { method: "GET", url: "task/taskInheritedDetail" },
          params: { id: this.invoiceTask.id },
          store: this.$store,
        }).then((res) => {
            if(res != false){
                _model = res.data.task;
                _model.i7= 1;
                _model.s11= '';

                request({
                    api: { method: "POST", url: "Task/PostInherited" },
                    data: { model: _model },
                    store: this.$store
                }).then(res => {
                    this.$bvToast.toast('Амжилттай баталгаажлаа.', {
                        title: "Мэдэгдэл",
                        autoHideDelay: 3000,
                        appendToast: true,
                        variant: "success",
                        toaster: "b-toaster-bottom-left"
                    });
                    this.$emit('on-hide');
                });
            }
        });
    },
    removeMembersFromInvoice(){
      request({
        api: { method: "POST", url: "TaskInUser/RemoveNotOwners" },
        data: { taskId: this.invoiceTask.id },
        store: this.$store
      }).then(res => {
        if(res != false){
          this.invoiceMembers();
        }
      });
    },
  }
}
</script>